import React, { useState, useRef, useEffect } from "react";
import { Box, Text, Button as ThemeUiButton } from "theme-ui";

import * as styles from "./ImageCarouselSelectGoalGear.styles";
import { SvgOrImg } from "components";

export default function ImageCarouselSelectGoalGear({
  imageContent = [],
  modalHeight,
  textBoxContent,
  disableScroll,
}) {
  const [activeSlide, setActiveSlide] = useState(0);
  const wrapperRef = useRef(null);

  const handleScroll = () => {
    const { width } = wrapperRef.current.getBoundingClientRect();
    const { scrollLeft } = wrapperRef.current;
    setActiveSlide(Math.round(scrollLeft / width));
  };

  const scrollCarouselOnClick = (index) => {
    const { width } = wrapperRef.current.getBoundingClientRect();
    wrapperRef.current.scrollLeft = width * index;
  };

  useEffect(() => {
    scrollCarouselOnClick(0);
  }, [JSON.stringify(imageContent)]);

  return (
    <Box sx={styles.imageContainer}>
      <Box
        ref={wrapperRef}
        sx={styles.carouselScrollContainer({ disableScroll, modalHeight })}
        onScroll={handleScroll}
      >
        <Box sx={styles.carouselMedia}>
          {imageContent.map(
            ({ url, alt, imageTitle, backgroundColor, textColor }, index) => {
              return (
                <Box
                  sx={styles.carouselItem({ backgroundColor })}
                  key={index + url}
                >
                  {imageTitle && (
                    <Text variant="h6" sx={styles.imageTitle({ textColor })}>
                      {imageTitle}
                    </Text>
                  )}
                  <SvgOrImg
                    src={url}
                    alt={alt || ""}
                    sx={styles.displayImage}
                    draggable={false}
                  />
                </Box>
              );
            }
          )}
          {textBoxContent && (
            <Box sx={styles.textBox}>
              <Text variant="h4" sx={styles.textBoxTitle}>
                {textBoxContent.title}
              </Text>
              <Text variant="copy2" sx={styles.textBoxDescription}>
                {textBoxContent.description}
              </Text>
            </Box>
          )}
        </Box>
      </Box>
      {imageContent.length > 1 && (
        <Box sx={styles.paginationDots}>
          {imageContent.map(({ url }, index) => {
            return (
              <ThemeUiButton
                variant="unstyled"
                sx={styles.paginationDot({
                  paginationDotsColor: imageContent[activeSlide].textColor,
                  isSelected: index === activeSlide,
                  backgroundColor: imageContent[activeSlide].backgroundColor,
                })}
                onClick={() => scrollCarouselOnClick(index)}
                key={"pagination" + index + url}
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
}
